<template>
  <header class="design-header">
    <button
      class="brand"
      type="button"
      aria-label="Return to main page"
      @click="emit('returnToMainPage')"
    >
      <img
        :src="logo"
        alt=""
        width="40"
        height="40"
      />
      <span>{{ descriptor }}</span>
    </button>
  </header>
</template>

<script setup lang="ts">
import { useCapitalizedDescriptor } from '@/composables/useCapitalizedDescriptor'

import logo from '../assets/logo.svg'

const emit = defineEmits<{(event: 'returnToMainPage'): void }>()

const descriptor = useCapitalizedDescriptor()
</script>

<style scoped lang="scss">
.design-header {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--sizes-6) var(--sizes-10);
}

.brand {
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
  padding: 0;
  cursor: pointer;
  text-align: left;
  letter-spacing: var(--font-letter-spacing-xs);
  color: inherit;
  border: 0;
  background: transparent;
  font-family: var(--font-family-paragraph);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  gap: 12px;

  img {
    flex-shrink: 0;
  }

  span {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  &:focus-visible {
    outline: 2px solid var(--color-brand-300);
    outline-offset: 6px;
  }
}

@media (max-width: 600px) {
  .design-header {
    padding: var(--sizes-5);
  }

  .brand {
    font-size: var(--font-size-m);
    gap: 8px;
  }
}
</style>
